import { Component } from '@angular/core';

export type NavGroup = {
  Name: string;
  Entries: NavEntry[];
}

export type NavEntry = {
  Name: string;
  Route: any[];
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent {
  
  public NavGroups: NavGroup[];
  public ShowLoader = false;
  
  constructor() {
    this.NavGroups = [
      {
        Name: 'General',
        Entries: [
          {
            Name: 'Messages',
            Route: ['/messages']
          },
          {
            Name: 'Tasks',
            Route: ['/tasks']
          }
        ]
      },
      {
        Name: 'Employees',
        Entries: [
          {
            Name: 'Overview',
            Route: ['/employees']
          },
          {
            Name: 'Calendar',
            Route: ['/employees/calendar']
          },
          {
            Name: 'Clock-In',
            Route: ['/labor-tracking']
          }
        ]
      },
      {
        Name: 'Inventory',
        Entries: [
          {
            Name: 'Barrels',
            Route: ['/barrels']
          },
          {
            Name: 'Contents',
            Route: ['/product-amounts']
          }
        ]
      },
      {
        Name: 'Distributors',
        Entries: [
          {
            Name: 'Marketing Files',
            Route: ['/marketing-files']
          }
        ]
      },
    ];
  }
}
